module.exports = __webpack_public_path__ + "static/Corprate_WhoWeAre_IF_mbheader-87d6b3be60f67698f66dd565105e6346.jpg";